import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BehaviorSubject, catchError, map, Observable, Subject, throwError } from 'rxjs'
import { environment } from 'src/environments/environment'

@Injectable({
    providedIn: 'root',
})
export class HealthMonitoringService {
    private apiServiceUrl = environment.apiUrl
    public deleteServiceModal = new Subject<any>()
    public editServiceModal = new Subject<any>()
    private actionSubject = new Subject<any>()
    private emailSubject = new BehaviorSubject<string>('')

    public actionObservable = this.actionSubject.asObservable()

    constructor(private http: HttpClient) {}

    public triggerAction(data: any) {
        this.actionSubject.next(data)
    }

    public clearEmail(): void {
        this.emailSubject.next('')
    }

    public getExternalServiceStatus(): Observable<any> {
        const url = `${this.apiServiceUrl}/aipo/platform/api/health/monitor/external-service-status`
        return this.http.get(url).pipe(
            map((response: any) => {
                return response.urlPayloads
            })
        )
    }

    public getExternalServiceList(): Observable<any> {
        const url = `${this.apiServiceUrl}/aipo/platform/api/health/monitor/external/services`
        return this.http.get(url).pipe(
            map((response: any) => {
                return response
            }),
            catchError((error: any) => {
                console.error('Error fetching external services list:', error)
                return throwError(() => new Error('Failed to load external services. Please try again.'))
            })
        )
    }

    public saveService(serviceData: any): Observable<any> {
        const url = `${this.apiServiceUrl}/aipo/platform/api/health/monitor/save-service`
        return this.http.post(url, serviceData).pipe(
            map((response: any) => {
                return response
            }),
            catchError((error: any) => {
                console.error('Error occurred while saving service:', error)
                return throwError(() => new Error('Error occurred while saving service. Please try again.'))
            })
        )
    }

    public updateService(serviceData: any): Observable<any> {
        const url = `${this.apiServiceUrl}/aipo/platform/api/health/monitor/update-service`
        return this.http.post(url, serviceData).pipe(
            map((response: any) => {
                return response
            }),
            catchError((error: any) => {
                console.error('Error occurred while updating service:', error)
                return throwError(() => new Error('Error occurred while updating service. Please try again.'))
            })
        )
    }

    public deleteService(requestId: string): Observable<any> {
        const url = `${this.apiServiceUrl}/aipo/platform/api/health/monitor/external/delete-service?requestId=${requestId}`
        return this.http.delete(url).pipe(
            catchError((error) => {
                console.error('Error occurred while deleting service:', error)
                return throwError('Error occurred while deleting service. Please try again.')
            })
        )
    }

    public updateServiceFlag(requestId: string, data: any): Observable<any> {
        const url = `${this.apiServiceUrl}/aipo/platform/api/health/monitor/update-flag?requestId=${requestId}`
        return this.http.post(url, data).pipe(
            map((response: any) => {
                return response
            }),
            catchError((error: any) => {
                console.error('Error occurred while updating service flag:', error)
                return throwError(() => new Error('Error occurred while updating service flag. Please try again.'))
            })
        )
    }

    public checkServiceDisabledPeriod(requestId: string): Observable<any> {
        const url = `${this.apiServiceUrl}/aipo/platform/api/health/monitor/service-status?requestId=${requestId}`
        return this.http.get(url).pipe(
            catchError((error) => {
                console.error('Error checking service status:', error)
                return throwError(() => new Error('Error checking service status. Please try again.'))
            })
        )
    }
}
